<template>
  <Container title="Precisamos da sua assinatura" :subtitle="subtitle" @on-submit="onSubmit" :noButton="!showButton">
    <template #form>
      <template v-if="showFormAssinatura">
        <v-expand-transition>
          <SelectAssinatura @assinatura-saved="afterSaveAssinatura" />
        </v-expand-transition>
      </template>
      <template v-else>
        <v-expand-transition>
          <ShowAssinatura :assinatura="assinatura" @on-click-edit="showFormAssinatura = true" />
        </v-expand-transition>
      </template>
    </template>
  </Container>
</template>

<script>
import assinaturaService from '@/services/assinatura'

import Container from '@/modules/FichaClinica/FichaClinicaContainer'
import SelectAssinatura from '@/modules/Assinatura/SelectAssinatura'
import ShowAssinatura from '@/modules/Assinatura/ShowAssinatura'

export default {
  components: {
    Container,
    SelectAssinatura,
    ShowAssinatura
  },
  data: () => ({
    disableButton: false,
    assinatura: null,
    nova_assinatura: false,
    showFormAssinatura: true,
    showButton: false,
    subtitle: 'Atualize ou veja sua assinatura'
  }),
  methods: {
    async buscaAssinatura() {
      this.$showLoading()
      try {
        const { data } = await assinaturaService.buscaAssinatura()
        if (data.nova_assinatura) {
          this.assinatura = data.assinatura
          this.nova_assinatura = data.nova_assinatura
          this.showFormAssinatura = false
          this.showButton = true
        } else {
          this.showButton = false
          this.subtitle = 'Atualize sua assinatura, escolha a que mais gostar'
        }
      } catch ({ response }) {
        this.$showErrorMessage(response.data.message)
      } finally {
        this.$hideLoading()
      }
    },
    async afterSaveAssinatura() {
      await this.buscaAssinatura()
      this.showFormAssinatura = false
    },
    onSubmit() {
      if (this.assinatura && this.nova_assinatura) {
        this.$router.push('finalizar')
      } else {
        this.showFormAssinatura = true
      }
    }
  },
  mounted() {
    this.buscaAssinatura()
  }
}
</script>
